export default ['', 'Name', 'Package', 'Price €', 'Article ID'];



// WEBPACK FOOTER //
// ./src/view/order/headers.ts